// React
import React, { useState, useEffect, useCallback } from "react";

// Kendo
import kendo from "@progress/kendo-ui";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";

// Css
import "./elderDisease.css"
import styles from "./elderDisease.module.css"

// Service
import { getUser, isAdmin, isDeveloper, isLogin } from "../../../service/authService";
import { getUserDiseaseList, deleteUserDisease } from "../../../service/mngt/elderService";

// Component
import { Delete } from "@material-ui/icons";
import ElderDiseaseAdd from './elderDiseaseAdd';
import ElderDiseaseEdit from './elderDiseaseEdit';

const ElderDisease = ({ conn, elderInfo, setElderInfo }) => {

  const userInfo = getUser();

  const [data, setData] = useState({
    userDiseaseList : [],
  })

  const [dataState, setDataState] = useState({
    userId: elderInfo.dataItem.userId,
  })


  // 보유지병 추가 팝업
  const addDisease = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.diseaseAddInfo = true;
      return item;
    });
  }

  // 보유지병 수정 팝업
  const editDisease = dataItem => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.diseaseEditInfo = true;
      item.selectedRow = dataItem;
      return item;
    });
  }

  // 닫기 이벤트
  const closeEvt = () => {
    setElderInfo(elderInfo => {
      const item = { ...elderInfo };
      item.diseaseInfo = false;
      return item;
    });
  };

  // 삭제 버튼
  const isDeletedBtn = dataItem => {
    // 삭제 여부 확인
    kendo
    .confirm("보유지병을 삭제 하시겠습니까?")
    .then(e => {
      deleteUserDisease(conn, dataItem).then(() => {
        getUserDiseaseList(conn, getUserDiseaseListCallback, getRejection, dataState);
        kendo.alert("보유지병이 삭제되었습니다.");
      })
    })
    .catch(e => {
      return;
    });
  };


  const getUserDiseaseListCallback = result => {
    setData((data) => {
      const item = { ...data };
      item.userDiseaseList = result;
      return item;
    })

  }

  const getRejection = reject => {
    console.log("getRejection = ", reject);
  };


  useEffect(() => {
    getUserDiseaseList(conn, getUserDiseaseListCallback, getRejection, dataState);
  }, []);

  return (
    <Dialog title={elderInfo.dataItem.userTerm +"님 보유지병"} onClose={closeEvt}>
      <div className={styles.diseaseDialog}>
        <Grid 
          className={styles.diseaseList}
          data={data.userDiseaseList}
          onRowClick={editDisease}
          >         
          <GridNoRecords><img style={{width: "340px", height: "240px"}} src="/images/noData_disease.png"/></GridNoRecords>
          <GridColumn field="diseaseTerm" title="지병" width="140px" />
          <GridColumn field="diseaseTermOther" title="지병(기타)" width="140px" />
          <GridColumn field="medicationYn" title="투약여부" width="100px"/>
          <GridColumn field="medicationNote" title="투약메모" />
          <GridColumn title="삭제" filterable={false} sortable={false} width="80px"
            cell={props => (
              <td>
                <a
                  onClick={e => {
                    e.preventDefault();
                    isDeletedBtn(props.dataItem);
                  }}>
                  <i>
                    <Delete />
                  </i>
                </a>
              </td>
            )}
          />
        </Grid>
        <div className={styles.content}>
          <Button onClick={addDisease}>보유지병 추가</Button>
          <Button onClick={closeEvt}>닫기</Button>
        </div>
      </div>
      {elderInfo.diseaseAddInfo === true && (
        <ElderDiseaseAdd
          conn={conn}
          elderInfo={elderInfo}
          setElderInfo={setElderInfo}
          getUserDiseaseListCallback={getUserDiseaseListCallback}
        />
      )}
      {elderInfo.diseaseEditInfo === true && (
        <ElderDiseaseEdit
          conn={conn}
          elderInfo={elderInfo}
          setElderInfo={setElderInfo}
          getUserDiseaseListCallback={getUserDiseaseListCallback}
        />
      )}
    </Dialog>
  );
};
export default ElderDisease;
